import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-terms-service',
    imports: [],
    templateUrl: './terms-service.component.html',
    styleUrls: ['./terms-service.component.css']
})
export class TermsServiceComponent implements OnInit {
  revisionDate = 'May 2026';

  constructor() { }

  ngOnInit(): void {
  }

}